<div class="cardEquipmentSection">
  @if (showBtnRemove()) {
  <div>
    <button class="btnRemove" (click)="update(false, card())">
      Eliminar de la lista <span></span>
    </button>
    @if (card().listImage && card().listImage.image) {
      <div class="contentImage">
        <img [ngSrc]="card().listImage.image" [alt]="card().listImage.alt" fill />
      </div>
    }
    <div class="tags">
      <div class="tagsPromotion">
        @if (card().isPromotion) {
          <p class="promotion">Promoción</p>
        }
        @if (card().isSpecialPrice) {
          <p class="specialPrice">Precio especial</p>
        }
        @if (card().isLiquidationPrice) {
          <p class="liquidation">Liquidación</p>
        }
        @if (card().isCcu) {
          <p class="tagCCU">CAT Certified Used</p>
        }
        @if (card().brand) {
          <p class="tagBrand">{{ card().brand.name | uppercase }}</p>
        }
      </div>
    </div>
    <div class="dataEquipment">
      <div class="modelEquipment">
        <h3>
          @if (card().name && card().name === '' && card().brand && card().brand.name !== '') {
            {{ card().brand.name }} {{ card().model }}
          } @else {
            {{ card().name }}
          }
        </h3>
      </div>
      <div class="subCategory">
        @if (card().subCategory) {
          <p>{{ card().subCategory.name }}</p>
        }
      </div>
      <div class="featuresGeneral">
        <div class="feature">
          <p class="title">Año:</p>
          <p class="value">
            @if (card().year) {
              {{ card().year }}
            }
          </p>
        </div>
        <div class="feature">
          <p class="title">Ubicación:</p>
          <p class="value">
            @if (card().municipality) {
              {{ card().municipality.name }},
              {{ card().municipality.state.name | titlecase }}
            }
          </p>
        </div>
        @if (card().hourMeter) {
          <div class="feature">
            <p class="title">Horas:</p>
            <p class="value">{{ card().hourMeter }}</p>
          </div>
        }
      </div>
      <div class="priceSection">
        <p class="title">Precio:</p>
        <div class="colPrice">
          <div class="newPrice">
            <p class="newValue">
              @if (card().isHiddenPrice) {
                Cotiza ahora
              } @else {
                @if (card().isSpecialPrice || card().isLiquidationPrice || card().isPromotion) {
                  $ {{ card().discountPrice | number: '1.2-2' }} {{ card().currency }}
                } @else {
                  @if (card().price && card().currency) {
                    $ {{ card().price | number: '1.2-2' }}
                    {{ card().currency }}
                  }
                }
              }
            </p>
          </div>
          @if (card().discountPrice > '0.00') {
            <div class="oldPrice">
              <p>$ {{ card().price | number: '1.2-2' }} {{ card().currency }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="buttonSection">
    <button class="btn btnTracsa btnYellow" (click)="openModalContactCard()">ME INTERESA</button>
    <button class="btn btnTracsa btnWhite" (click)="goToEquipment()">VER DETALLE</button>
    @if (show()) {
      <mat-checkbox
        class="btnCheck"
        [checked]="check()"
        [disabled]="!check() && disabled()"
        (change)="update($event.checked, card(), $event)"
        >Comparar</mat-checkbox
      >
    }
  </div>
} @else {
  <div class="cardBody" (click)="goToEquipment()">
    @if (card().listImage && card().listImage.image) {
      <div class="contentImage">
        <img [ngSrc]="card().listImage.image" [alt]="card().listImage.alt" fill />
      </div>
    }
    <div class="tags">
      <div class="tagsPromotion">
        @if (card().isPromotion) {
          <p class="promotion">Promoción</p>
        }
        @if (card().isSpecialPrice) {
          <p class="specialPrice">Precio especial</p>
        }
        @if (card().isLiquidationPrice) {
          <p class="liquidation">Liquidación</p>
        }
        @if (card().isCcu) {
          <p class="tagCCU">CAT Certified Used</p>
        }
        @if (card().brand) {
          <p class="tagBrand">{{ card().brand.name | uppercase }}</p>
        }
      </div>
    </div>
    <div class="dataEquipment">
      <div class="modelEquipment">
        <a
          [routerLink]="
            `/equipo-usado/categorias/${card().subCategory.category.slug}/${card().subCategory.slug}/${card().economicNumber}`
          "
        >
          <h3>
            @if (card().name && card().name === '' && card().brand && card().brand.name !== '') {
              {{ card().brand.name }} {{ card().model }}
            } @else {
              {{ card().name }}
            }
          </h3>
        </a>
      </div>
      <div class="subCategory">
        @if (card().subCategory) {
          <p>{{ card().subCategory.name }}</p>
        }
      </div>
      <div class="featuresGeneral">
        <div class="feature">
          <p class="title">Año:</p>
          <p class="value">
            @if (card().year) {
              {{ card().year }}
            }
          </p>
        </div>
        <div class="feature">
          <p class="title">Ubicación:</p>
          <p class="value">
            @if (card().municipality) {
              {{ card().municipality.name }},
              {{ card().municipality.state.name | titlecase }}
            }
          </p>
        </div>
        @if (card().hourMeter) {
          <div class="feature">
            <p class="title">Horas:</p>
            <p class="value">{{ card().hourMeter }}</p>
          </div>
        }
      </div>
      <div class="priceSection">
        <p class="title">Precio:</p>
        <div class="colPrice">
          <div class="newPrice">
            <p class="newValue">
              @if (card().isHiddenPrice) {
                Cotiza ahora
              } @else {
                @if (card().isSpecialPrice || card().isLiquidationPrice || card().isPromotion) {
                  $ {{ card().discountPrice | number: '1.2-2' }} {{ card().currency }}
                } @else {
                  @if (card().price && card().currency) {
                    $ {{ card().price | number: '1.2-2' }}
                    {{ card().currency }}
                  }
                }
              }
            </p>
          </div>
          @if (card().discountPrice > '0.00') {
            <div class="oldPrice">
              <p>$ {{ card().price | number: '1.2-2' }} {{ card().currency }}</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="buttonSection">
    <button class="btn btnTracsa btnYellow" (click)="openModalContactCard()">ME INTERESA</button>
    <button class="btn btnTracsa btnWhite" (click)="goToEquipment()">VER DETALLE</button>
    @if (show()) {
      <mat-checkbox
        class="btnCheck"
        [checked]="check()"
        [disabled]="!check() && disabled()"
        (change)="update($event.checked, card(), $event)"
        >Comparar</mat-checkbox
      >
    }
  </div>}
</div>

<ng-template #modalContactCard>
  <div class="formGeneral">
    <div class="headerForm">
      <p class="titlePopUp">
        @if (card().name && card().name === '' && card().brand && card().brand.name !== '') {
          {{ card().brand.name }} {{ card().model }}
        } @else {
          {{ card().name }}
        }
      </p>
      <button class="closeButton" mat-dialog-close (click)="close()">
        <img src="/used-equipment/Home/x.svg" alt="Tracsa-Cerrar" />
      </button>
    </div>
    <div class="formBody">
      <app-general-contact
        [interested]="false"
        [namePage]="
          'Equipo Usado: ' +
          card().subCategory.name +
          '/' +
          card().economicNumber +
          ', Serial Number: ' +
          card().serialNumber
        "
        [thanksPage]="'equipo usado'"
      ></app-general-contact>
    </div>
  </div>
</ng-template>
